/* Share and save controls in the article header.
 *
 * Share uses the native share sheet where the browser has one (every mobile
 * browser, which is where articles are actually read) and copies the link
 * otherwise. Save is deliberately local-only: the store has no customer
 * accounts, so a reading list can live in localStorage or not exist at all.
 */
(function () {
  var SAVED_KEY = 'netrabindu:saved-articles';

  function readSaved() {
    try {
      var raw = window.localStorage.getItem(SAVED_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (err) {
      // Private mode, disabled storage, or someone else's malformed value.
      return [];
    }
  }

  function writeSaved(list) {
    try {
      window.localStorage.setItem(SAVED_KEY, JSON.stringify(list));
      return true;
    } catch (err) {
      return false;
    }
  }

  var toastEl;
  var toastTimer;

  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      // Inline styles rather than utility classes: this element is created
      // after Tailwind has already been compiled and purged.
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.style.cssText = [
        'position:fixed', 'left:50%', 'bottom:24px', 'z-index:60',
        'transform:translateX(-50%) translateY(12px)',
        'background:#1b1c1a', 'color:#fbf9f6',
        'padding:10px 18px', 'border-radius:999px',
        'font-size:14px', 'line-height:1.4', 'max-width:calc(100vw - 32px)',
        'text-align:center', 'pointer-events:none', 'opacity:0',
        'transition:opacity .18s ease, transform .18s ease',
      ].join(';');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    requestAnimationFrame(function () {
      toastEl.style.opacity = '1';
      toastEl.style.transform = 'translateX(-50%) translateY(0)';
    });
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toastEl.style.opacity = '0';
      toastEl.style.transform = 'translateX(-50%) translateY(12px)';
    }, 2200);
  }

  function copyLink(url) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(url);
    }
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (err) {
        ok = false;
      }
      document.body.removeChild(field);
      ok ? resolve() : reject(new Error('copy failed'));
    });
  }

  document.querySelectorAll('[data-article-share]').forEach(function (button) {
    button.addEventListener('click', function () {
      var url = button.getAttribute('data-share-url') || window.location.href;
      var title = button.getAttribute('data-share-title') || document.title;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function (err) {
          // A user dismissing the share sheet raises AbortError; that is not a
          // failure and must not fall back to copying behind their back.
          if (err && err.name === 'AbortError') return;
          copyLink(url).then(function () {
            toast('Link copied');
          }).catch(function () {
            toast('Could not share this article');
          });
        });
        return;
      }

      copyLink(url).then(function () {
        toast('Link copied');
      }).catch(function () {
        toast('Could not copy the link');
      });
    });
  });

  document.querySelectorAll('[data-article-save]').forEach(function (button) {
    var key = button.getAttribute('data-article-key');
    if (!key) return;

    var iconOff = button.querySelector('[data-save-icon="off"]');
    var iconOn = button.querySelector('[data-save-icon="on"]');
    var labelSave = button.getAttribute('data-label-save') || 'Save this article';
    var labelSaved = button.getAttribute('data-label-saved') || 'Saved';

    function paint(isSaved) {
      button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
      button.setAttribute('aria-label', isSaved ? labelSaved : labelSave);
      if (iconOff) iconOff.classList.toggle('hidden', isSaved);
      if (iconOn) iconOn.classList.toggle('hidden', !isSaved);
      button.classList.toggle('text-botanical-gold-text', isSaved);
    }

    paint(readSaved().indexOf(key) !== -1);

    button.addEventListener('click', function () {
      var list = readSaved();
      var at = list.indexOf(key);
      var nowSaved = at === -1;

      nowSaved ? list.push(key) : list.splice(at, 1);

      if (!writeSaved(list)) {
        toast('Your browser is blocking saved articles');
        return;
      }
      paint(nowSaved);
      toast(nowSaved ? 'Saved — find it on the Journal page' : 'Removed from saved');
    });
  });
})();
